import generateUtilityClass from '../../utils/esm/generateUtilityClass/generateUtilityClass.esm.js';
import generateUtilityClasses from '../../utils/esm/generateUtilityClasses/generateUtilityClasses.esm.js';

function getSwitchBaseUtilityClass(slot) {
  return generateUtilityClass('PrivateSwitchBase', slot);
}
generateUtilityClasses('PrivateSwitchBase', ['root', 'checked', 'disabled', 'input', 'edgeStart', 'edgeEnd']);

export { getSwitchBaseUtilityClass };
